import { useEffect, useState } from "react";
import AddUsermodal from "./AddUsermodal";
import RemoveUserModal from "./RemoveUserModal";
import jwtDecode from "jwt-decode";
import { Button } from "react-bootstrap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useAuth from "../../hooks/useAuth";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserSecret, faUserMinus } from "@fortawesome/free-solid-svg-icons";

function VendorUsers(props) {
  const { vendorId, languages } = props;
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const [users, getUsers] = useState("");
  const [isUserOpen, setIsUserOpen] = useState(false);
  const [isUserDelete, setIsUserDelete] = useState(false);
  const [userId, setUserId] = useState("");
  const [usersName, setUsersName] = useState("");
  const [usersLastName, setUsersLastName] = useState("");
  const [usersEmail, setUsersEmail] = useState("");
  const [token, setToken] = useState();
  const [pswHshs, setPswhsh] = useState();
  const [decodedToken, setDecodedToken] = useState(null);
  let getToken = auth?.accessToken;
  useEffect(() => {
    setToken(getToken);
    setDecodedToken(jwtDecode(getToken));
  }, [getToken]);


  const getAllUsers = async () => {
    let isMounted = true;
    const controller = new AbortController();
    try {
      const response = await axiosPrivate.get(`vendors/id=${vendorId}`, {
        signal: controller.signal,
      });
      isMounted && getUsers(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const impersonateUser = async (id) => {
    console.log("imporsonating", pswHshs, id);

    if (!pswHshs) return console.log("No password hash");

    let redirectUrl;
    let newTab;
    let res;

    axios({
      method: "POST",
      url: `${process.env.REACT_APP_ADMIN_API_HOST}/users/login/${id}`,
      data: { username: decodedToken.user_id, passwordHash: pswHshs },
    }).then(async (response) => {
        res = response;
        redirectUrl = response.data.redirectUrl;
        newTab = window.open(redirectUrl, "_blank"); 
        console.log("Open", redirectUrl);

        console.log("Open", redirectUrl);
      }).catch((error) => console.log(`Error as: ${error}`));

      console.log("addEventListener");
      window.addEventListener("message", function handleReadyMessage(event) {
        console.log("RECEIVED", event.data, event.origin);
        if ( event.data === "ready" && event.origin === process.env.REACT_APP_ADMIN_HOST ) {
          console.log("SENT form", event.origin);
          newTab.postMessage(res.data, redirectUrl);
          window.removeEventListener("message", handleReadyMessage);
        }
      });

    return;
  };

  const getAdminC = async () => {
    let isMounted = true;
    const controller = new AbortController();
    try {
      const response = await axiosPrivate.get(
        `getAdminC/userEmail=${decodedToken.user_id}`,
        {
          signal: controller.signal,
        }
      );
      setPswhsh(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getAllUsers();
  }, [vendorId]);

  useEffect(() => {
    getAdminC();
  }, [decodedToken]);

  const setUserDelete = (id, name, last_name, email) => {
    setUserId(id);
    setUsersName(name);
    setUsersLastName(last_name);
    setUsersEmail(email);
    setIsUserDelete(true);
  };

  const logInAsUser = (id) => {
    setUserId(id);
    impersonateUser(id);
  };

  const onRemoveModalClose = () => {
    getAllUsers();
    setIsUserDelete(false);
  };
  const onAddUserClose = () => {
    getAllUsers();
    setIsUserOpen(false);
  };

  const DisplayUsers = (users) => {
    if (users.length > 0) {
      return users.map((user, index) => {
        return (
          <>
            <div key={user.id} className="row prcVendorDetailsUser">
              <div className="col-md-6">
                <span className="hideDesktop">UPORABNIK: </span>
                {user.name + " " + user.surname + " (" + user.email + ")"}
              </div>
              <div className="col-md-1">
                <span className="hideDesktop">JEZIK: </span>
                {user.language}
              </div>
              <div className="col-md-3">
                <span className="hideDesktop">VLOGA: </span>
                {user.role}
              </div>
              <div className="col-md-1 prcVendorDetailsUserLogin">
                <span className="hideDesktop">IZBRIŠI UPORABNIKA: </span>
                {user.role === "USER" && (
                  <FontAwesomeIcon
                    icon={faUserMinus}
                    title="Izbriši uporabnika"
                    style={{ color: "red" }}
                    onClick={() =>
                      setUserDelete(
                        user.id,
                        user.name,
                        user.surname,
                        user.email
                      )
                    }
                  />
                )}
              </div>
              {user.role === "USER" && (
                <div className="col-md-1 prcVendorDetailsUserLogin">
                  <span className="hideDesktop">PRIJAVI SE KOT: </span>
                  <FontAwesomeIcon
                    icon={faUserSecret}
                    title="Prijavi se kot uporabnik"
                    style={{ color: "#007bff" }}
                    onClick={() => logInAsUser(user.id)}
                  />
                </div>
              )}
            </div>
          </>
        );
      });
    } else {
      <div className="row">
        <div className="col-md-12 ">Podjetje nima še nobenega uporabnika</div>
      </div>;
    }
  };
  return (
    <div>
      <div className="prcVendorDetailsUsers">
        <div className="row prcVendorDetailsTitleRow">
          <div className="col-sm-6">
            <strong>UPORABNIKI</strong>
          </div>
          <div className="col-sm-6 text-sm-right">
            <Button
              variant="secondary"
              onClick={() => setIsUserOpen(true)}
              vendorId={users.vendor_id}
            >
              Dodaj uporabnika
            </Button>
          </div>
        </div>
        <div className="row prcVendorUsersHeader hideMobile">
          <div className="col-md-6">
            <p>UPORABNIK</p>
          </div>
          <div className="col-md-1">
            <p>JEZIK</p>
          </div>
          <div className="col-md-4">
            <p>VLOGA</p>
          </div>
        </div>
        {DisplayUsers(users)}
        <AddUsermodal
          open={isUserOpen}
          onClose={() => onAddUserClose()}
          vendorId={vendorId}
          userLanguages={languages}
        />

        <RemoveUserModal
          open={isUserDelete}
          onClose={() => onRemoveModalClose()}
          vendorId={vendorId}
          userId={userId}
          usersName={usersName}
          usersLastName={usersLastName}
          usersEmail={usersEmail}
        />
      </div>
    </div>
  );
}

export default VendorUsers;
